var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M8.877 16.34a7.463 7.463 0 1 0 0-14.925 7.463 7.463 0 0 0 0 14.925M18.463 20.22l-3.516-3.515a1.236 1.236 0 0 1 0-1.758c.49-.49 1.277-.49 1.758 0l3.516 3.516c.489.489.489 1.277 0 1.758-.49.489-1.277.489-1.758 0M14.947 14.947l-.796-.796"
})));
export default SvgSearch;